import axios from '@/api';
import authHeader from '@/services/auth-header';


export async function createLinkToken(fileName, dir) {
    const { data } = await axios.post(process.env.VUE_APP_API_URL + 'file/createLink', {
        fileName, dir
    }, {
        headers: authHeader(),
        withCredentials: true
    });

    return data;
}